const en = {
  dateStartBeforeDateFinal: "The start date cannot be greater than the end date",
  applyFilter: "Apply Filter",
  rangeDateInfo: "If no date is entered (start or end), the report will display data for the entire period, starting from the player's registration date.",
  seeNotification: "See",
  viewed: "Seen",
  notViewed: "Not seen",
  wantToDeleteThisMessage: "Do you want to delete this message?",
  deleteMessage: "Delete menssage",
  editMessage: "Edit menssage",
  addNotificationText: "By default, the system sends messages to all players. To send messages to specific players, search by name or ID below",
  seeSelectedUsers: "View selected users (ID's)",
  newMessage: "New message",
  selectTags: "Select Tags",
  massImportAffiliatesMIN: "You must have at least 1 (one) user to import",
  massImportAffiliatesMAX: "You can only import 1000 (one thousand) affiliates at a time",
  massImportAffiliatesRequiredColumns: `Maximum of 1000 affiliates per import.<br> The columns “local_manager_id”, “login”, “name” and “password” are mandatory for importing affiliates in mass.`,
  massImportAffiliates: "Import affiliates in mass",
  importAffiliates: "Import Affiliates",
  someErrorsWereFound: "Some errors were found",
  operationLog: "Operation log",
  noTagsCreated: "There are no tags created.",
  prizeFreespinsQtt: "Qty. Freespins prizes",
  prizeFreespinsAmount: "Total freespins prizes",
  casinoReferenceDay: "Reference Day",
  prizeRefundAmount: "Total prize refund",
  prizeRefundQtt: "Qty. Prize Refund",
  betRefundAmount: "Total Bet Refund",
  betRefundQtt: "Qty. Betting refunds",
  gameId: "Game ID",
  registeredUsers: "Registered users",
  usersByCampaign: "Users by campaign",
  wonBet: "Won",
  lostBet: "Lost",
  resultDate: "Result Date",
  numberOfGames: "No. of games",
  multiplier: "Multiplier",
  consultedOn: "Consulted on",
  irreversibleAction: "This action is irreversible.",
  tagsConfig: "Tags",
  createTag: "Create tag",
  createNewTag: "Create new tag",
  seeTags: "Show tags",
  playerTags: "Player Tags",
  addTag: "Add tag",
  addTags: "Add tags",
  removeTags: "Remove tag | Remove tag | Remove tags",
  confirmRemoveTagText: "Are you sure you want to delete the selected tag(s)?",
  maxTagsReached: "Maximum number of 5 tags reached",
  noTagsAvailable: "No tags available",
  tipRemoveTag: "Tip: Click on the tag you want to remove from this player",
  tipSelectMaxTags: "Select up to {maxQtyPlayerTags} tags",
  yourTags: "Your tags",
  manageTags: "Manage tags",
  editTags: "Edit tags",
  color: "Color",
  selectColor: "Select a color",
  selectTag: "Select a tag",
  noTagFound: "No tags found",
  create: "Create",
  insertTitle: "Insert a title",
  seeGames: "See games",
  irreversibleActionExemptPlayer:
    "This action is irreversible: The linked player cannot be edited or removed.",
  playerName: "Player name: {playerName}",
  searchExemptPlayer: "Exempt Player Search",
  searchAffiliate: "Search Affiliate(s)",
  linkExemptPlayerBtn: "Link exempt player",
  linkAffiliateExemptPlayerBtn: "Link to an Exempt Player",
  linkExemptPlayerAffiliates: "Link Exempt Player to Affiliate(s)",
  linkAffiliateExemptPlayer: "Link Affiliate to a Exempt Player",
  idTransaction: "Transaction ID",
  typePix: "Type of Pix",
  valueCpa: "CPA Value",
  loadingData: "Loading data",
  cpaLabel: "CPA",
  playerId: "Player ID",
  details: "Details",
  cpaValue: "CPA Value",
  cpaType: "CPA Type",
  lclManager: "Lcl. Manager",
  regManager: "Reg. Manager",
  percent: "Percentage",
  noCommission: "No commission",
  chooseGroupByOption:
    "It is necessary to choose an option in Group by: game or provider.",
  lobbyAll: "Lobby: All",
  newCasino: "New Casino",
  providerCategories: "Provider's Categories",
  gameSettings: "Game settings",
  chooseAtLeastOneCategoryOrProvider:
    "At least one custom category or provider must be chosen",
  casinoVolatility: `Volatility is provided by game providers.
  This is used to indicate to players how often
  how the slot assigns payouts, and how high they might
  wait for the payments.`,
  casinoRTP: `RTP: The return to player, or RTP, in any game,
  is the expected percentage of bet amounts that
  a specific game will return to the player over the course of
  a period of time.`,
  high: "High",
  "very-high": "Very-high",
  medium: "Medium",
  "medium-high": "Medium-high",
  low: "Low",
  "low-medium": "Low-medium",
  payout: "Payout",
  fixedRate: "Fixed Rate",
  commissionCpa: "Commissioning by CPA",
  withoutCommission: "Without Commissioning",
  guestBy: "Display 'Indicated by'",
  volatilityRating: "Volatility",
  categoryWeight: "Category Weight",
  commissionTypeCpa: "Commissioning Type",
  maxValueCommission: "Maximum Commission Value",
  minDepositCpa: "Minimum Deposit Value",
  turnover: "Turnover For Deposit",
  tooltipCpa: `Cost Per Action<br>
  <ul>
  <li>Commission type: Referring to each player's first deposit.</li>
  <li>Minimum deposit amount: Minimum value of each player's first deposit.</li>
  <li>Maximum commission value: Maximum value that your affiliated will be commissioned based on the defined CPA.</li>
  </ul>`,
  tooltipTurnover:
    "To be eligible for commission, the player must use the deposited amount in sports betting or casino games.",
  categoryWeightTxt:
    "'Category weight' determines a category's placement in the casino's listing. For example: A 'Popular Games' category that has a weight of 50 will appear in the list before a 'New Games' category that has a weight of 40. A category's weight can range from 0 to 999.",
  customCategories: "Custom Categories",
  systemGameStatus: "System game status",
  visibleGameTxt: `
    <span>The game will be showing if:</span>
    <ul>
      <li>Be included in at least one category</li>
      <li>At least one category must be active</li>
      <li>The game status on the system must be active</li>
    </ul>
   `,
  noDescription: "No description",
  selectCategory: "Select category",
  gameDisplayed: "Game displayed",
  casinoTheme: "Theme",
  verticalCategory: "Vertical category",
  showLess: "Show less",
  showMore: "Show more",
  filterByVerticalCategory: "Filter by Provider's Category",
  filterByCasinoTheme: "Filter by Theme",
  readLess: "Read less",
  readMore: "Read more",
  lobbyCasino: "Lobby: Casino",
  lobbyCasinoLive: "Lobby: Casino Live",
  filterByCategories: "Filter by custom categoriy",
  filterByGameProviders: "Filter by Providers",
  filterByLobby: "Filter by Lobby",
  noCategory: "No category",
  others: "others",
  outras: "others",
  image: "Image",
  gamesProviders: "Games Providers",
  categoryNameLabel: "Category Name",
  areYouSureToDelete: "Are you sure you want to exclude the category?",
  deletingCategoryAlert:
    "The following action will delete the existing game category and the games configured to appear in this category will lose this status. You can configure them to appear in other categories.",
  customCategory: "Custom category",
  standardCategory: "Standard",
  casinoType: "Casino Type",
  createCategory: "Create Category",
  editCategory: "Edit Category",
  deleteCategory: "Delete Category",
  ativa: "Active",
  inativa: "Inactive",
  weight: "Weigth",
  categories: "Categories",
  games: "Games",

  noDataOptions: "No available options",
  noDataTablePlayers: "No players to list",
  filterBy: "Filter by",
  dataByRegion: "Data by Region",
  qtdPlayers: "Qty. of Players",
  homeGraphicTitle: {
    overviewDescription:
      "Transactions with online balance of Sportsbook and Casino.",
    sports: "Sports Betting",
    casino: "Casino Betting",
    offensivePlayers: "Players Against the House",
    noOffensivePlayers: "Players in Favor of the House",
    averageDailyDescription:
      "Average Ticket: {average} | Average Prizes: {average} | Average Daily Revenue: {average}",
  },
  homeChartLineOptions: {
    sports: {
      title: "Sports Betting - Chart",
      // verticalLabel: "R$",
      horizontalLabel: "Day/Month",
    },
    casino: {
      title: "Casino Betting - Chart",
      // verticalLabel: "R$",
      horizontalLabel: "Day/Month",
    },
  },
  listAndExportTokensTip: "List / Export Tokens",

  redeemedTokens: "Redeemed Tokens",
  dateUse: "Activation Date",
  quantityOfTokensAsterisk: "Quantity of Tokens *",
  quantityOfTokens: "Quantity of Tokens",
  notRansomed: "Not redeemed",
  ransomed: "Redeemed",
  exportTokens: "Export Tokens",
  token: "Token",
  usersActivesByAffiliateTooltip:
    "Minimum active users reached | Missing 1 active user | Missing {remainingUsers} active users",
  usersActivesByAffiliateExplanation:
    "To be commissioned you need to reach the minimum number of active users",
  qtyUsersActives: "Active Users Quantity",
  usersActivesByAffiliate: "Active / Minimum Users",
  minActiveUsers: "Minimum Active Users",
  differentAspectRatio: "The image is in a different proportion than expected",
  exportAdhesions: "Export adhesions",
  claimExport: "Claim export",
  exportTransfers: "Export transfers",
  minutes: "minute | minute | minutes",
  balanceType: "Balance Type",
  realBalance: "Real Balance",
  agentBet: "Agent Bet",
  onlineBetting: "Online Betting",
  allBets: "All Bets",
  hour: "hour",
  hourCapitalized: "Hour",
  toManyTryLogin:
    "Your device has been blocked from access for {timeLeft} due to multiple login attempts.",
  defaultFeeError: "The fee ranges from 0 to 99. Use integer numbers",
  defaultFeeTooltip:
    "The standard rate is a service fee that will be applied on top of the affiliate's GGR. You can change this rate individually, when registering a new affiliate, unchecking the 'Apply Default Fee' option",
  defaultFee: "Default Fee",
  defaultFeeSettingsAndVariableCommissions: "Affiliates Settings",
  updateAffiliateVariableCommission: "Update Affiliate Variable Commission",
  updateAffiliateCommissionType: "Update Affiliate Commission Type",
  updateFixedAffiliateCommission: "Update Fixed Affiliate Commission",
  updateAffiliateFee: "Update Affiliate Fee",
  requestedByCustumer: "Requested by customer",
  reason2: "Incorrect pix key, adjust it and request again",
  reason3: "Player actions violate our policies",
  cancelWithdrawByOperator: "Withdraw Canceled by Operator",
  // reasonCancelWithdrawLabel: "Enter the reason",
  cancelWithdraw: "Cancel Withdrawal",
  adviseCancelWithdraw: "An SMS will be sent to the player with the reason:",
  feeValue: "Fee Value",
  feeValueCommission: "Fee Commission",
  prizesCasino: "Prizes Casino",
  betCasino: "Bets Casino",
  betCasinoQty: "Qty. Bets Casino",
  prizeCasinoQty: "Qty. Prizes Casino",
  betsPrizeQty: "Qty. Prizes",
  activePlayers: "Affiliated Players",
  analyticReport: "Analytic Report",
  draggableHint:
    "You can change the display order of the banners by dragging the images to the desired position!",
  urlNo: "Please enter a valid URL.",
  addPromotionUser: {
    title: "Link promotion to a user",
    selectDeposit: "Select deposit",
    infoUser:
      "This user is linked to the '{titlePromo}' promotion. If you confirm the link, it will lose the current rollover progress and if any bet related to the previous promotion is pending, it will no longer be valid.",
    error: {
      selectPlayer: "Select a player",
      noDeposits: "User without deposits",
      selectDeposit: "Select a deposit",
    },
    success: "User added promotion",
  },
  removeCasinoGamesByAdm: "Remove Casino Games",
  insertCasinoGamesAdm: "Insert Casino Games",
  updateOperatorPaymentMethods: "Update Operator Payment Methods",
  seePromotion: "See promotion",
  tokenTip:
    "Token is a randomly generated, unique and exclusive code that can only be activated once by a betting user. Enter the amount of tokens you want to create for this promotion. Ex.: 1000",
  bonusMax: "Maximum Bonus",
  promotionDetails: "Promotion Details",
  multMaxValueTip:
    "Determines the maximum multiplier to bet with the bonus coming from this promotion. Eg: Bets with a total multiplier greater than 12.55 will not be allowed with this bonus.",
  multMinValueTip:
    "Determines the minimum multiplier to bet with the bonus coming from this promotion. Eg: Bets with a total multiplier less than 2.23 will not be allowed with this bonus.",
  stakeMinValueTip1:
    "It is the minimum amount that will be accepted per bet in this promotion. Ex.: The bonus will only be valid for bets from",
  stakeMinValueTip2: "5.",
  depositMinValueTip:
    "Minimum amount that the bettor needs to deposit to be able to join the promotion.",
  bonusMaxValueTip:
    "Maximum amount that will be credited in bonuses after counting the percentage on top of the deposited amount.",
  prmotionTypeRegisterOrAfiliateTip:
    "Net amount in bonus that will be credited after registration from this promotion.",
  promotionTypeDepositTip:
    "Percentage on top of the deposited amount that will be credited as a bonus when joining this promotion.",
  promotionCodeTip:
    "Code that the bettor will use to join the promotion. Ex.: AFFILIATEEARNS200, SIGNUP100, etc.",
  bonusTotalResgatado: "Total Bonus Redeemed",
  bonusTotalConcedido: "Total Bonus Awarded",
  promotion: "Promotion",
  startBonus: "Start Bonus",
  notInForce: "Not in force",
  inForce: "In force",
  userExtract: "User statement",
  adhesionTooltip: "List of users who have joined this promotion",
  pleaseStandBy: "Please stand by...",
  applyDefaultFee: "Apply default fee",
  redeemed: "Redeemed",
  encerrada: "Ended",
  suspensa: "Suspended",
  ativas: "Actives",
  inativas: "Inactives",
  adhesionExtract: "Adhesion Extract",
  subsequentBalance: "Subsequent Balance",
  nameOperation: "Operation Name",
  entryDate: "Entry Date",
  userStatus: "User Status",
  expiration: "Expiration",
  currentRollover: "Current Rollover",
  totalRollover: "Total Rollover",
  idBanca: "Operator ID",
  idPromotion: "Promotion ID",
  adhesions: "Adhesions",
  adhesion: "Adhesion",
  searchById: "Search by ID",
  deletedImage: "Image deleted!",
  noImageLoaded: "No image loaded.",
  deleteImage: "Delete",
  warningMaxSize: "The image exceeds the maximum allowed size: 1800x700",
  loadImageSuccess: "Image successfully loaded!",
  timeStart: "Time start",
  day: "day",
  commissionLive: "Live",
  commissionPrematch: "PreMatch",
  dialogCommissionLive:
    "If there is at least one live event in the bet, the live commission applies.",
  idAffiliate: "Affiliate ID",
  loadImage: "Load image",
  firstDeposit: "First deposit",
  acceptedFormats: "Accepted formats: .png, .jpg, .jpeg",
  inactivePromo: "Inactive",
  activePromo: "Active",
  finalizedPromo: "Finished",
  cancelledPromo: "Canceled",
  expiredPromo: "Expired",
  LabelMaximumBonusAmount: "Maximum bonus amount",
  autoCompleteAffiliatePlaceHolder: "Enter a name for the query *",
  showMainEvents: "Display Main Events?",
  addImage: "Add Image",
  maxTransference: "Max transfer",
  rulesAndOperation: "Rules and operation",
  rolloverDetails: "Rollover Details",
  percentageLabel: "%",
  minimumDeposit: "Minimum Deposit",
  daysToExpire: "Days to expire *",
  daysToExpireTableHeader: "Days to expire",
  days: "days",
  cashoutDetachedAuthorizedByCollab:
    "Manual Withdrawal Authorized By Collaborator",
  cashoutDetachedAuthorizedByAdm:
    "Manual Withdrawal Authorized By Administrator",
  detachedDepositByAdm: "Manual Deposit Online By Administrator",
  detachedDepositByColab: "Manual Deposit Online By Collaborator",
  customLandingPages: "Custom Landing Pages",
  LPTitleLabel: "Title",
  errorUploadingLandingPage: "An error has occurred! Please try again.",
  successfullyLandingPage: "Landing Page sent successfully!",
  textAreaWithoutCode: "We need the source code to save the landing page!",
  landingPagePlaceHolder:
    "Paste the source code of your landing page here. Or use our editable template by clicking 'Load Template'.",
  medias: "Medias",
  gameName: "Game Name",
  of: "of",
  eventNumber: "Number of Events",
  verificationNotStarted: "Not Verified",
  verificationSuccess: "Verified",
  verificationInProgress: "In Progress",
  verificationDenied: "Verification Denied",
  collaboratorTooltip:
    "Collaborators are people who do not need full access to the system. Create permission groups and then assign them to Collaborators.",
  groupsTooltip:
    "Groups are the permissions assigned to a Collaborator. They will allow or not the Collaborator to view menus or perform actions.",
  loginAsCollaborator: "Login as Collaborator",
  atLeastOneOption: "You did not select an permission!",
  emptyFields: "There are unfilled fields",
  selectPermissions: "Select Actions:",
  insertNewGroupName: "Insert the new group name:",
  groupName: "Group's name",
  group: "Group",
  managed: "Managed",
  createPermissionsGroup: "New Permissions Group",
  permissions: "Permissions",
  listPermissions: "List Permissions",
  updatePermissions: "Edit Permissions",
  listCollaborators: "List Collaborators",
  collaborator: "Collaborator",
  collaborators: "Collaborators",
  block: "Block",
  editCollaboratorRegisterData: "Edit Registration Data",
  groups: "Groups",
  editCollaborator: "Edit Collaborator",
  newCollaborator: "New Collaborator",
  registerCollaborator: "Register Collaborator",
  idUser: "User ID",
  warningAboutBanks:
    "Watch out! When deleting a bank, the player who has a pix key verified with that bank will have to go through the verification process again.",
  allowedBanksConfiguration: "Banks Configuration",
  selectAtLeastOneBank: `Please select at least one bank or configure the bank verification setting to "No".`,
  languages: "Languages",
  termsOfUse: "Terms of Use",
  responsibleGambling: "Responsible Gambling",
  dataProtection: "Data Protection",
  aml: "AML",
  totalBetsValue: "Total Bets",
  totalBetsAmount: "Qty. of Bets",
  totalValidBetsValue: "Total Valid",
  totalValidBetsAmount: "Valid Amount",
  totalRefundedBetsValue: "Total Refunded",
  totalRefundedBetsAmount: "Refunded Amount",
  totalPrizesValue: "Prizes",
  totalPrizesAmount: "Qty. of Prizes",
  groupBy: "Group By",
  document: "Document",
  documents: "Documents",
  betCashout: "Cashout",
  chooseBanks: "CHOOSE BANKS",
  bankVerification: "Bank Verification",
  banks: "Banks",
  allowedBanks: "Select the allowed banks:",
  startTypingABank: "Start typing a bank",
  chooseBanksHint: `
    If you want to restrict banks, select "Yes" and choose the banks you want to allow. (Recommended) <br/>
    If you want to allow all banks, you can select "No"
  `,
  selectAll: "Select all",
  removeAll: "Remove all",
  playerNameIsRequired: "Enter an ID, name, login, phone or Email!",
  autoCompleteNoData: "No query data",
  cantCalculateSurebet:
    "It is not possible to calculate the profit as one or more odds are suspended.",
  surebetFormula: "Estimated calculation based on Surebet's formula",
  hideEstimatedProfit: "Hide estimated profit",
  showEstimatedProfit: "Show estimated profit",
  selectAgent: "Select an agent.",
  firstDepoist: "First Deposit",
  finishedBet: "Finished",
  finishedBetPlural: "Finished",
  withTransactions: "Export by player who made deposit or withdrawal",
  noRegister: "There is no registration",
  activation: "Activation",
  suspension: "Suspension",
  massAgentsUpdateTitle: "Mass Agent Update",
  massAgentsUpdateTitleMobile: "Agent Update",
  massAgentsUpdateContent:
    "Choose an action to perform on the agents of the manager {managerName}.",
  massAgentsSuspensionTitle: "Mass Agent Suspension",
  massAgentsSuspensionTitleMobile: "Agent Suspension",
  massAgentsSuspensionContent:
    "All agents for the manager will be suspended. Are you sure you want to continue?",
  massAgentsActivationTitle: "Mass Agent Activation",
  massAgentsActivationTitleMobile: "Agent Activation",
  massAgentsActivationContent:
    "All agents of the manager will be activated. Are you sure you want to continue?",
  bonusConsumed: "Bonus Consumed",
  groupCreated: "Group Created",
  groupUpdated: "Group Updated",
  promotionInserted: "Promotion Inserted",
  promotionDeleted: "Promotion Deleted",
  changingStatusOfSelfSuspendedPlayer:
    "It is not possible to change the status of a self-suspended player.",
  suspendedSince: "Suspended since: ",
  selfSuspended: "Self-suspended",
  limitSuspensionDate: "Suspended until",
  playerSuspended: "Player Suspension",
  doubleAccount: "More Than One Account",
  suspiciousBehavior: "Suspicious Behavior",
  textAreaPlaceholderSuspension:
    "Enter a brief reason for the user's suspension.",
  textAreaPlaceholderDisable:
    "Please enter a brief reason for disabling the user.",
  suspensionReason: "Reason",
  disableReason: "Disable Reason",
  warningDisable:
    "This action can only be undone by opening a ticket with support.",
  bugAbuse: "Bug Abuse",
  outdatedInformation: "Outdated Information",
  termsAndConditionsViolation: "Terms and Conditions Violation",
  financialProtection: "Financial Protection",
  other: "Other",
  selectAReasonToSuspend: "Select a reason to suspend the user's account",
  selectAReasonToDisable: "Select a reason to disable the user's account",
  depositBalance: "Deposit Balance",
  loginButton: "Login",
  editAgentBalance: "Edit Agent Balance",
  agentBalance: "Agent Balance",
  incrementAgentBalance: "Addition to Agent Balance",
  betsWithDeposit: "Bets with Deposit Balance",
  betsWithBonus: "Bets with Bonus Balance",
  totalOnlineBalanceDescription: "Total online players balance",
  onlineBalance: "Online Balance",
  bonusBalance: "Bonus Balance",
  totalOnlineBalance: "Balance",
  paymentMethods: "Payment Methods",
  copyCode: "Copy code",
  depositForPlayerPayment: "Deposit payment",
  depositForPlayerPixDescription:
    "You are making a deposit for a player. The payment method is PIX, and the amount of $ {value} will be credited to the player's account a few seconds after the payment is confirmed.",
  depositForPlayerManualDescription:
    "You are making a manual deposit for a player. $ {value} will be credited to the player's account.",
  depositForPlayer: "Deposit",
  login: "Login",
  portuguese: "Portuguese",
  spanish: "Spanish",
  english: "English",
  hiWelcome: "Hello, welcome!",
  navigateSideMenu: "Navigate through the side menu.",
  print: "Print",
  paidBets: "Paid bets",
  paidBet: "Pay the Bet",
  wantPaidBet: "Do you want to pay the bet",
  search: "Search",
  live: "Live",
  resumeSummary: "Resume summary",
  value: "Value",
  prizePaids: "Prizes paid",
  prizePossibles: "Prizes possible",
  prizeTotal: "Total prizes",
  code: "Code",
  info: "Information",
  events: "Events",
  dateHour: "Date/Hour",
  return: "Return",
  result: "Result",
  action: "Actions",
  activeAgents: "Active agents",
  weeklyChart: "Weekly Chart",
  grossAndPremium: "Gross and Premium",
  from: "From",
  areas: "Areas",
  until: "Until",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  gross: "Gross",
  labelCurrency: "$",
  awards: "Awards",
  informations: "Information",
  dateTime: "Date/Time",
  paid: "Paid",
  actions: "Actions",
  canceledList: "Canceled list",
  deferredList: "Deferred List",
  view: "View",
  periodSummary: "Period Summary",
  paidPremiuns: "Premiums Paid",
  passibleAwards: "Possible Awards",
  totalPrizes: "Total Awards",
  cancelledIn: "Canceled in",
  amount: "Amount",
  player: "Player",
  sellerCode: "Seller Code",
  operation: "Operation",
  commission: "Commission",
  status: "Status",
  cancelCredit: "Cancel Credit",
  msgConfirmCancelCredit: "Do you really want to cancel credit from",
  consultedBy: "Consulted by",

  dayAndTimeOfPrinting: "Day and time of printing",
  newRegionalManager: "New Regional Manager",

  name: "Name",
  createdIn: "Created in",
  edit: "Edit",

  registrationForm: "Registration Form",
  fullName: "Full Name",
  settings: "Settings",
  profitCommission: "Profit commission",
  areaOfExpertise: "Area of Expertise",
  regionalCreditforAgents: "Can this Regional manage credit for Agents?",
  regionalLimitsforAgents: "Can this Regional manage Agent limits?",
  credentials: "Credentials",
  changePassword: "Change password",
  password: "Password",
  confirmPassword: "Confirm Password",
  toSave: "Save",
  yes: "Yes",
  no: "No",
  thisFieldIsRequired: "This field is required.",
  repeatPassword: "Repeat password",
  activate: "Activate",
  pending: "Pending",
  supend: "Suspend",
  disable: "Disable",
  newLocalManager: "New Local Manager",
  profile: "Profile",
  regionalManager: "Regional Manager",
  localCreditforAgents: "Can this Site manage credit for Agents?",
  localLimitsforAgents: "Can this Site manage Agent limits?",
  localAdminPaidBets: "Can this Site manage bet payouts?",
  newAgent: "New Agent",
  viewBets: "View Bets",
  commissions: "Commissions",
  mLocal: "M. Local",
  mRegional: "M. Regional",

  subordination: "Subordination",
  mobile1: "Mobile 1",
  mobile2: "Mobile 2",
  address: "Address",
  toSaveStateMsg: "To save a State and City, you must enter a valid zip code.",
  state: "State",
  limits: "Limits",
  valuePerMatch: "Value per Match (in Single bet)",
  dailyBettingLimit: "Daily Betting Limit",
  dailyLimitSingleBets: "Daily Limit for Single Bets",
  dailyLimitDoubleBets: "Daily Limit for Double Bets",
  maximumAgentAward: "Maximum Agent Award",
  creditSaleLimit: "Credit Sale Limit",
  generalSalesLimit: "General Sales Limit",
  generalSalesLimitIncrement: "General Sales Limit Addition",
  reset: "Reset",
  activateLive: "Activate Live",
  vieAwardees: "View Awardees",
  automaticPayment: "Automatic payment?",
  marginOfQuotation: "Margin of Quotation",
  commissionsOnCreditSales: "Commission on credit sales",
  maximumMutiplier: "Bet maximum Multiplier",
  minimumMultiplier: "Bet minimum Multiplier",
  // accessCredential: "Access Credential",
  active: "Active",
  blocked: "Blocked",
  phoneMustCointais11Digits: "Phone must contain 11 digits",
  CPFMustCointais11Digits: "CPF must contain 11 digits",
  city: "City",
  remarks: "Remarks",
  newCollector: "New collector",
  routesToCollect: "Routes to collect",
  closings: "Closings",
  regionalIdManager: "Regional Manager ID",
  collector: "Collector",
  agent: "Agent",
  route: "Route",
  payCollect: "Pay/Collect",
  noRouteToCollect: "No route to collect",
  summary: "Summary",
  payable: "Payable",
  toCollect: "To collect",
  total: "Total",
  newRoute: "New Route",
  nameCollector: "Collector Name",
  routeName: "Route Name",
  linkRegional: "Link Regional",
  selectRegional: "Select regional",
  linkAgents: "Link Agents",
  selectAgents: "Select Agents",
  previous: "Previous",
  users: "Users",
  page: "Page",
  next: "Next",
  dtRegistration: "Registration Date",
  cellPhone: "Mobile",
  download: "Download",
  actives: "Actives",
  inactives: "Inactives",
  inactivesPlayersMsg:
    " * Inactive: Players who have not logged in in the last 30 days or who have never logged in.",
  noDataForthisQuery: "There is no data for this query.",
  canPlaceBetsOnline: "You can place bets online",
  balance: "Balance",
  factor: "Factor",
  bets: "Bets",
  validBets: "Valid bets",
  exemptBets: "Exempt bets",
  credit: "Credit",
  userUnconfirmedAccontMsg:
    "This user appears with his unconfirmed account. You can resend the confirmation link.",
  resentSMS: "Resend SMS",
  resentEmail: "Resend Email",
  awardRedemption: "Award Redemption",
  whichAgentIdCanRequest:
    "Here you can define which agent id the user (player) can request to redeem his rewards.",
  whichAgentIdCanRequestAffiliate:
    "Here you can define which agent id the user (player) can be affiliated with.",
  searchAgent: "Search an agent",
  defineTheAgent: "Define the agent (enter only the Agent Id)",
  userLimits: "User Limits",
  realiabilityFactor: "Reliability Factor",
  newArea: "New Area",
  subAreaOf: "Sub area of",
  promotionDescription: "Description *",
  description: "Description",
  areaName: "Area Name",
  areaDescroption: "Area Description",
  grouped: "Grouped",
  list: "List",
  qtyBet: "Qty.Bet ",
  salesBets: "Sales Bets",
  cancelledBets: "Canceled Bets",
  coAgentBet: "Co.Agent (Bet)",
  coAffiliateBet: "Co. Affiliate (Bet)",
  qtyCredits: "Amount. Credits",
  salesCredits: "Sales Credits",
  coAgentCredit: "Co.Agent (Credit)",
  coGerLocal: "Co. Local Mng.",
  grossProfit: "Gross Profit",
  coRegionalManager: "Co. Regional Mng.",
  netProfit: "Net income",
  qtyAgents: "Agents Quantity",
  qtyAffiliates: "Affiliates Quantity",
  credits: "Credits",
  coAgentCreditSales: "Co.Agent (Credit Sales)",
  coRegionalCreditSales: "Regional Co. (Credit Sales)",
  agentName: "Agent Name",
  numbersOfAgents: "Number of Agents",
  numberOfAffiliates: "Number of Affiliates",
  commissionRegionalOnGrossProfit:
    "Regional Manager's Commission on Gross Profit.",
  amountBetsSold: "Amount of bets sold",
  bettingSalesValue: "Betting Sales Value",
  reverseOfCanceledBets: "Reverse Canceled Bets",
  agentsCommissiononBettingSales: "Agent's commission on betting sales",
  amountOFCreditsSold: "Amount of credits sold",
  creditSalesAmount: "Credit Sales Amount",
  agentCommissionInfoKey: "Agent's commission on the sale of credits",
  localManagerCommissionInfoKey: "Local Manager's Commission on Agent Sales",
  awardValue: "Award value",
  netProfitResume:
    "Net Profit is the gross profit minus the regional manager's commission",
  groosProfitResume:
    "Gross profit is total sales minus commissions and premiums",
  launch: "Launch",
  previousBalance: "Previous Balance",
  gerLocal: "Mgr Local",
  qty: "Qty.",
  sales: "Sales",
  // cancellations: "Cancellations",
  balanceReport: "Balance",
  totalBalance: "Total Balance",
  extract: "Extract",
  extractAgent: "Extract Agent",
  filter: "Filter",
  date: "Date",
  salesQty: "Sales Qty",
  verified: "Verified",
  canceled: "Canceled",
  rights: "Rights",
  dayBalance: "Day Balance",
  finalBalance: "Final Balance",
  noDrivesFount: "No drives found.",
  filterFrom: "Filter from",
  category: "Category",
  lastPickup: "Last Pickup",
  depostiForPaymentOfPremiums: "Deposit for payment of premium(s)",
  miscellaneoutDeposit: "Miscellaneous deposit",
  reverse: "Reverse",
  is: "To",
  type: "Type",
  receiveFromTheAgent: "Receive from Agent",
  payTheAgent: "Pay the Agent",
  launchedBy: "Launched By",
  receivedPaid: "Received/Paid",
  received: "Received",
  paids: "Paid",
  TOTAL: "TOTAL",
  releases: "Releases",
  region: "Region",
  area: "Area",
  amountBet: "Amount Bet",
  betCanceled: "Bet. Canceled",
  regionalCo: "Regional Co.",
  coAgentSalesBets: "Co.Agent (Sale of Bets)",
  qtyBets: "Qty. of Bets",
  graphic: "Graph",
  news: "New",
  olds: "Olds",
  championship: "Championship",
  match: "Match",
  nOfBets: "No. of Bets",
  simple: "Simple",
  multiples: "Multiples",
  lost: "Lost",
  add: "Add",
  combinationAnalysis: "Combination Analysis",
  exactly: "Exact",
  combination: "Combination",
  simulationOnProvider: "Simulation on Provider",
  betAmount: "Bet amount",
  possibleReturn: "Possible return",
  totalCommission: "Total commission",
  betting: "Betting",
  youtReturnWouldBe: "Your return would be",
  countryLeague: "Country/League",
  league: "League",
  event: "Event",
  odd: "Quotation",
  filters: "Filters",
  toFilter: "Filter",
  country: "Country",
  tournament: "Tournament",
  postponed: "Postponed",
  suspended: "Suspended",
  thisEventCannotBeCanceled: "This event cannot be canceled!",
  thisEventCannotBeSuspended: "This event cannot be suspended!",
  all: "All",
  allowedFieldUpTo100: "Allowed field up to 100%",
  toSelect: "Select",
  institutional: "Institutional",
  workWithusAndContact: "WORK WITH US AND CONTACT",
  publicContactEmail: "Public contact email:",
  socialNetWorks: "SOCIAL NETWORKS (OPTIONAL)",
  aboutYourCompany: "ABOUT YOUR COMPANY",
  tellAboutYourBusiness: "Tell your audience a little ABOUT your business:",
  registrationDataBilling: "Registration Data / Billing",
  dataResponsible: "DATA RESPONSIBLE",
  dataAddress: "ADDRESS DATA",
  number: "Number",
  neighborhood: "Neighborhood",
  generalSettings: "General Settings",
  promotions: "Promotions",
  informPromotionsByYourBusiness:
    "Inform your audience of promotions promoted by your business:",
  toCancel: "Cancel",
  billingEmail: "Billing email",
  addressData: "ADDRESS DATA",
  generalSettingsAgents: "General Settings - Agents",
  cancellationOfBetByAgent: "CANCELLATION OF BET BY AGENT",
  cancelBet: "Cancel bet",
  minutesToCancel: "Minutes to cancel",
  generalSettingsPortal: "General Settings - Portal",
  portalOptions: "PORTAL OPTIONS",
  acceptPreBet: "Accept Prebet?",
  activateLiveModule: "Activate live module?",
  minutesAllowrdOnLive: "Minutes allowed in Live",
  generalSettingsBanking: "General Settings - Banking",
  controlOfLimits: "CONTROL OF LIMITS",
  numbersOfDaysInTable: "Numbers of days in table",
  maximumEventsPerBet: "Maximum events per bet",
  maximumBankingAward: "Maximum banking award",
  minimumBetAmount: "Minimum bet amount",
  maximumValueOfBet: "Maximum value of a bet",
  minimumMultiplierForABet: "Min. multiplier for bet",
  maximumMultiplierForABet: "Max. multiplier for bet",
  doNotDisplayQuotesBelow: "Do not display quotes below",
  maximumLimitByOptionOnEvent: "Maximum limit per option on event",
  maximumLimitByMarketOnEvent: "Maximum limit per market on event",
  percentUserCanHighLimit: "Percent. the user can use of the maximum limit",
  PRINT: "PRINT",
  observation: "Observation",
  reulationForThePortal: "REGULATION FOR THE PORTAL",
  filterByCountry: "Filter by country",
  selectASport: "Select a sport",
  noDataFount: "No data found!",
  selectAMarket: "Select a market",
  preGame: "Pre-Game",
  Live: "Live",
  oddMax: "Odd Max",
  recommendedImagiSizeBanner:
    "Recommended aspect ratios for the banner image are: 3:1 (e.g: 900x300px, 1200x400px) up to 5:2 (e.g: 1500 x 600px, 1000 x 400px), in .png or .jpg file formats with a max. of 2MB. When uploading images, always try to send images in the same proportion.",
  recommendedImagiSizeParner:
    "Recommended image size for Partners, License, Payment methods 100x100 pixels (.png, .jpg or .gif) with max. of 1Mb.",
  recommendedImagiSizePopup:
    "Recommended image size for Pop-up 512x512 pixels (.png, .jpg or .gif) with max. 1Mb.",
  recommendedImagiSizePromoImage:
    "Recommended image size 1800x700 pixels (.png or .jpg) with max. 1Mb.",
  recommendedImagiSizeMenu:
    "Recommended image size for 300px menu width with relative height (.png, .jpg or .git) with max. 1Mb.",
  selectABanner: "Select a banner:",
  addBanner: "Add Banner",
  errorDeletingImage: "An error occurred deleting your image: ",
  chooseAnImageFirst: "Please choose an image first.",
  imageTooLarge: "Image too large (2MB maximum)",
  fileTypeNotAllowed: "File type not allowed! Only .png, .jpg or .gif allowed.",
  fileTypeNotAllowedImage: "File type not allowed! Only .png or .jpg allowed.",
  maximum6Images: "Maximum 6 images.",
  bannerSentsuccessfully: "Banner sent successfully.",
  errorUploadingBanner: "An error occurred while uploading your banner: ",
  banners: "Banners",
  partners: "Partners",
  license: "License",
  toView: "View",
  sgaNotifications: "SGA Notifications",
  yourNotifications: "Your Notifications",
  subject: "Subject",
  noSubject: "No subject",
  read: "read",
  notRead: "Unread",
  toActive: "Activate",
  toDisable: "Disable",
  toSend: "Send",
  openInvoice: "Open Invoice",
  payment: "Payment",
  dueDate: "Expiration",
  interest: "Interest",
  pay: "pay",
  seccondCopy: "Second copy",
  ticket: "boleto",
  period: "Period",
  plan: "Plan",
  amountTotal: "Total Value",
  errorGeneratingDuplicate: "Error generating duplicate",
  enterYourCurrentPassword: "Enter your current password",
  currentPassword: "Current password",
  enterANewPassword: "Enter a new password",
  newPassword: "New Password",
  enterPasswordHinit:
    "Enter an 8-character password containing letters and numbers.",
  confirmNewPassword: "Confirm new password",
  inputRequired: "This field is required.",
  generalSettingsTransactions: "General Settings - Transactions",
  minimumDepositAmount: "Minimum Deposit Amount",
  depositFee: "Deposit Fee",
  maximumWithdrawalValue: "Maximum Draw Value",
  minimumWithdrawalAmount: "Minimum Withdrawal Amount",
  withdrawalRate: "Withdrawal Rate",
  minBonusBetMultiplier: "Min Bonus Bet Multiplier",
  minMetaBonusMultiplier: "Min Bonus Meta Multiplier",
  percentageOfBonus: "Bonus Percentage *",
  maximumBonusAmount: "Maximum Bonus Amount",
  solicitedBonus: "Solicited Bonus",
  cosolidatedBonus: "Consolidated Bonus",
  cancelledBonus: "Cancelled Bonus",
  bonusID: "Bonus ID",
  requisted: "Requested",
  registered: "Registered",
  consolidated: "Consolidated",
  didCancelled: "Cancelled",
  deposits: "Deposits",
  withdrawals: "Withdrawals",
  user: "User",
  amountOfDeposits: "Amount of Deposits",
  amountOfWithdrawals: "Amount. Withdrawals",
  authorized: "Authorized",
  depositID: "Deposit ID",
  deposit: "Deposit",
  withdrawalID: "Withdrawal ID",
  authorization: "Authorization",
  phone: "Phone",
  randomKey: "Random key",
  consolidatedValue: "Consolidated Value",
  authorizePayment: "Authorize Payment",
  userID: "User ID",
  toConfirm: "Confirm",
  confirmWithdrawalAuthorization: "Confirm withdrawal authorization?",
  authorizeWithdrawal: "Authorize Withdrawal",
  revenues: "Revenue",
  commissionRegionalOnGrossGGR: "Regional Manager's Committee on the GGR.",
  valueOnSoldBets: "Value on sold bets",
  valueInAwards: "Value in Awards",
  ggrExplanation: "GGR is the billing amount subtracting the premium amount.",
  feeGGRPercentageExplanation: "Service fee applied on top of the GGR.",
  valueNGRExplanation: "Net after application of service fees.",
  agentCommissionExplanation: "Agent's Commission on the GGR",
  affiliateCommissionExplanation: "Affiliate's Commission on the GGR",
  localCommissionExplanation: "Local Manager's Commission on GGR",
  valuesFinancial: "Financial Values",
  awarded: "Awarded",
  quantities: "Quantities",
  AmountLostBets: "Lost Bets Amount",
  amountAwarded: "Awarded Amount",
  pendings: "Pending",
  amountPending: "Pending Amount",
  betsAmount: "Bets Amount",
  bonusBet: "Bonus Bet",
  maximumInstantWithdrawalValue: "Maximum Instant Withdrawal Value",
  minimunDepoistAmount: "Minimum Deposit Amount.",
  minimumMultiplierToGoalBonus:
    "Minimum Multiplier to reach the goal and redeem the Bonus",
  percentageOnDeposit: "Percentage on deposits.",
  maximumValueOfWithdrawal: "Maximum value of a withdrawal.",
  minimumValueOfWithdrawal: "Minimum value of a withdrawal.",
  percentageOnWithdrawals: "Percentage on withdrawals.",
  percentageOfBonusOperator: "Bonus set bonus percentage.",
  limitMaximumAmountBonus: "Limit the maximum amount for bonuses.",
  minimulMultiplerForBettingBonus:
    "Minimum Multiplier for Betting with Bonus Balance",
  maximumValueUserWithdrawInstantly: "Maximum value a user can draw instantly",
  affiliates: "Affiliates",
  affiliate: "Affiliate",
  nameAffiliate: "Affiliate Name",
  searchAffiliateSpan: "Search by ID, name, login or E-mail of your affiliate",
  findAnAffiliate: "Find an Affiliate",
  singleAffiliate: "Single affiliate",
  players: "Players",
  depositsAndWithdrawals: "Deposits and Withdrawals",
  promotionLabelBonus: "Bonus *",
  bonus: "Bonus",
  configuration: "Configuration",
  accountability: "Accountability",
  account: "Account",
  reports: "Reports",
  system: "System",
  listBets: "List Bets",
  listCredits: "List Credits",
  playersList: "Players List",
  inactivePlayers: "Inactive Players",
  extractByUser: "Extract by User",
  betsPDV: "Bets Sales Retail",
  historic: "History",
  regionalManagers: "Regional Managers",
  editRegionalManager: "Edit Regional Manager",
  localManagers: "Local Managers",
  editLocalManager: "Edit Local Manager",
  editAgent: "Edit Agent",
  agentBettingCommision: "Commissions - Events Range",
  collectors: "Collectors",
  editCollector: "Edit Collector",
  routes: "Routes",
  editRoute: "Edit Route",
  listAreas: "List Areas",
  editArea: "Edit Area",
  eventsBetting: "Betting events",
  defense: "Defense",
  generalFinding: "General Finding",
  areaFinding: "Area Finding",
  routesFinding: "Routes Finding",
  agentRelease: "Agent Release",
  balanceByRoute: "Balance by Route",
  editOdd: "Edit Odd",
  bankConfiguration: "Bank Configuration",
  manageLeagues: "Manage Leagues",
  marketsAndMargins: "Markets and Margins",
  manageMedia: "Manage Media",
  notifications: "Notifications",
  notification: "Notification",
  invoices: "Invoices",
  invoice: "Invoice",
  agents: "Agents",
  historyLocalBettingManager: "History Local Betting Manager",
  balancePerRoute: "Balance by route",
  cashCollector: "Cash Collection",
  newRelease: "New Release",
  collectorReport: "Collector Report",
  agentCreditHistory: "Agent Credit History",
  agentsList: "Agents List",
  enterCurrentPassword: "Enter your current password",
  labelCurrentPassword: "Current password",
  labelNewPassword: "New Password",
  hintNewPassword:
    "Enter an 8-character password containing letters and numbers.",
  btnChangePassword: "Change password",
  rulesPassMatch: "This field is mandatory.",
  rulesRepeatPassword: "Repeat password",
  labelLogin: "Login",
  printDate: "Day and time of printing:",
  btnPrint: "Print",
  labelSearch: "Search",
  itemsPerPage: "Rows per page",
  justResume: "Summary",
  localManagerId: "ID Local MGR",
  localManagerName: "Local MGR.",
  agentId: "Agent ID",
  headersAgentName: "Agent",
  grossValue: "Gross Value",
  prizeValue: "Awards",
  valueGGR: "Gross Gaming Revenue",
  valueGGRProjected: "Revenue (Online Balance)",
  agentCommission: "AGT. Commission",
  affiliateCommission: "AFL. Commission",
  localManagerCommission: "Local MGR. Commission",
  regionalManagerCommission: "Regional MGR. Commission",
  qtdAgents: "Qty. Agents",
  qtdBets: "Qty. Bets",
  infoAgentName: "Agent's Name",
  infoAffiliateName: "Affiliate's Name",
  infoQtdAgent: "Quantity of agents",
  infoGrossValue: "Value in bets sold",
  infoPrizeValue: "value in awards",
  infoValueGGR: "GGR is the billing amount subtracting the premium amount",
  infoAgentCommission: "Agent's Commission on the GGR",
  infoLocalCommission: "Local Manager's Commission on the GGR",
  infoRegionalCommission: "Regional Manager's Commission on the GGR",
  editedEvent: "Edited Event",
  valorSome: "Valor_some",
  idLabel: "ID",
  infosLabel: "Information",
  eventsLabel: "Events",
  dateLabel: "Date/Time",
  valueLabel: "Value",
  returnLabel: "Return",
  resultLabel: "Result",
  paidLabel: "Paid",
  actionsLabel: "Actions",
  paidPrizes: "Paid Awards",
  possiblePrizes: "Possible Awards",
  extractLabel: "Extract",
  releaseLabel: "Release",
  releasesLabel: "Releases",
  collectorExtract: "Collector's Statement",
  collectorLabel: "Collector",
  codeLabel: "Code",
  categoryLabel: "Category",
  statusLabel: "Status",
  remainingBalance: "Remaining Balance",
  agentStatement: "Agent Statement",
  totalReceivedFromManager: "Total received from Manager",
  totalPaidToAgent: "Total paid to Agent(s)",
  totalReceivedFromAgent: "Total received from the Agent(s)",
  finalBalanceLabel: "Final Balance",
  consolidateAndRegisterInCash: "consolidate and register in financial box",
  regionalFinancialBox: "Regional Financial Box",
  pediodAfterLastCollection: "Period after the last collection",
  newLaunch: "New Release",
  receivedLabel: "Received",
  paidLabelCollector: "Paid",
  notConsolidated: "Not Consolidated",
  isConsolidated: "Consolidated",
  prizeDepositPayment: "Deposit for payment of prize(s)",
  miscellaneousDeposit: "Miscellaneous deposits",
  chargeback: "Chargeback",
  filterByDate: "Filter by Date",
  commissionSales: "Commission",
  cancellations: "Cancellations",
  canceledBets: "Canceled Bets",
  deals: "Hits",
  countSales: "Total Sales",
  qtdLabel: "Qty.",
  releasesPaid: "Paid",
  releaseReceived: "Received",
  totalLabel: "Total",
  releasedBy: "Released by",
  btnFilter: "Filter",
  agentLabel: "Agent",
  periodLabel: "Time course:",
  dailyBalance: "Daily Balance",
  dateHeader: "Date",
  extractAgentAlert: "No financial transactions found",
  to: "To",
  balanceLabel: "Balance",
  launchType: "Type",
  receiveFromAgent: "Receive from the Agent",
  payToAgent: "Pay to Agent",
  btnSave: "Save",
  valueEntryRules: "This field is required",
  userLabel: "User",
  revenueLabel: "Revenue",
  agentsComissionsLabel: "Agent's Commissions",
  qtdSalesCredit: "Qty. Sales Credits",
  qtdCredit: "Qty. Credits",
  creditSales: "Credit Sales",
  salesCreditCommi: "Credit Sales Commissions",
  agentBetCommission: "Agent's Commission (Sold Bets)",
  agentCreditCommission: "Agent's Commission (Sold Credits)",
  localManagerCommiGross: "Local Managers Commissions (Gross)",
  regionalManagerCommiLiquid: "Regional Manager Commission (Net)",
  betsLabel: "Bets",
  soldBets: "Sold Bets",
  fullCollection: "Full collection",
  totalDepositPremiumPayment: "Total deposit for premium payment",
  totalMiscellaneousDeposit: "Total miscellaneous deposit",
  totalChargeback: "Total Chargeback",
  collection: "Collection",
  miscellaneouDeposit: "Miscellaneous Deposit",
  msgFeedBackSetCash: "Description longer than 80 characters",
  accounting: "Accounting",
  retention: "Retention",
  registrationDate: "Registration Date",
  unlimitedLabel: "Unlimited",
  unlimited: "UNLIMITED",
  localManagerLabel: "Local Manager",
  fullNameLabel: "Full Name",
  cpfLabel: "CPF",
  emailLabel: "Email",
  cellphoneOneLabel: "Mobile 1",
  cellphoneTwoLabel: "Mobile 2",
  cepLabel: "Zip-Code",
  addressLabel: "Address",
  stateLabel: "State",
  cityLabel: "City",
  commentsLabel: "Comments",
  limitsLabel: "Limits",
  valuePerMatchSingleBet: "Value per Match (in Single Bet)",
  dailyBetLimit: "Daily Betting Limit",
  settingsLabel: "Settings",
  activateLiveLabel: "Activate Live",
  viewAwardees: "View Award Bets",
  accessCredential: "Access Credentials",
  passwordLabel: "Password",
  openRegister: "Open Register",
  alertRouteCollect: "No routes to collect",
  toPay: "To pay",
  routeLabel: "Routes",
  selectRoutes: "Select Routes",
  routeNameLabel: "Route Name",
  schedule: "Time",
  client: "Client",
  selection: "Selection",
  market: "Market",
  conference: "Conference",
  printingTime: "Printing Time",
  prohibitedForUnder18: "Prohibited for under 18s",
  double: "Double",
  triple: "Triple",
  multiple: "Multiple",
  wantCancelTheBet: "Really want to cancel the bet",
  betConference: "BETTING CONFERENCE",
  noValidForAwardReceipt: "(NO VALID FOR AWARD RECEIPT)",
  reverseAmount: "Reverse Amount",
  right: "Right",
  refund: "Refund",
  missed: "Missed",
  betCod: "Bet cod. ",
  datas: "Data",
  noRouteLinked: "No Route Linked",
  noAgentLinked: "No agent linked",
  update: "Update",
  submitBetId: "Submit bet id!",
  toClose: "Close",
  localManager: "Local Manager",
  searchPlayers: "Search Players ",
  searchPlayer: "Search Player",
  seachPlayersMsg: "Search by ID, name, login, phone or Email",
  dateRange: "Date range",
  toClean: "Clean",
  terminal: "Terminal",
  general: "General",
  breaks: "Breaks",
  today: "Today",
  yesterday: "Yesterday",
  lastMonth: "Last month",
  currentWeek: "This week",
  lastWeek: "Last week",
  lastSevenDays: "Last 7 days",
  halfMonth: "Last 15 days",
  currentMonth: "Current Month ",
  invalidTime: "Invalid time",
  weeklyCalculation: "Weekly Calculation",
  currentCalculation: "Current Calculation",
  paidAndReceiverFromAgent: "Paid and Received from agent",
  onlyReceivedFromAgent: "Only 'Received' from agent",
  onlyPaitToTheAgent: "Only 'Paid' to the agent",
  losts: "Lost",
  didSuspended: "Suspended",
  doActives: "Active",
  cancelleds: "Cancelled",
  statusEvent: "Event Status",
  cancelledsMasc: "Canceled",
  depositRequested: "Deposit Requested",
  depositConsolidated: "Deposit Consolidated",
  depositCancelled: "Deposit Cancelled",
  withdrawalRequisted: "Withdrawal Requested",
  withdrawalAuthorized: "Authorized Withdrawal",
  withdrawalConsolidated: "Consolidated Withdrawal",
  withdrawalCancelled: "Withdrawal Cancelled",
  bonusCancelled: "Bonus Cancelled",
  bonusRequested: "Bonus Requested",
  bonusConsolidated: "Consolidated Bonus",
  byValue: "By Value",
  exactValue: "Exact value:",
  valueGreaterThan: "Value greater than:",
  valueLessThan: "Value less than:",
  consultBet: "Consult Bet",
  network: "Network",
  weeklyCalculationReport: "Weekly Calculation Report",
  currenccalculationReport: "Current Calculation Report",
  report: "Report",
  copySuccessfully: "Copy Successfully!",
  unexpectedErrorOccured:
    "An unexpected error occurred, please try again later!",
  notStarted: "Not Started",
  inProgress: "In progress",
  documentInAnalysis: "In Analysis",
  finished: "Finished",
  didPostponed: "Postponed",
  interrupted: "Interrupted",
  abandoned: "Abandoned",
  closeToStart: "Close to start",
  pageNotFound: "Page not found",
  comeBack: "Back",
  _homePage: "Home Page",
  byUser: "By user",
  readQRcodeToPayPIX:
    "To make payment via pix, read the Qr Code in your bank's application or click the button to copy the code.",
  depositAmount: "Deposit amount",
  or: "OR",
  repeatThePassword: "Confirmation must be the same as the password",
  darkTheme: "Dark Theme",
  administrator: "Administrator",
  reasonFroCancellation: "Reason for cancellation",
  reason: "Reason",
  bet: "Bet",
  witdhdrawalAuthorized: "Withdrawal Authorization",
  FilteredPeriod: "Filtered period",
  seller: "Seller",
  comissionGerLocal: "Local manager commission (gross)",
  coAgent: "Com. Agent",
  agentCommissions: "Agent Commissions",
  assessment: "Assessment",
  oddMargin: "Odd Margin",
  currentCredit: "Current Credit",
  retentionLimit: "Retention Limit",
  rowsPerPage: "Rows per page:",
  linkedRoutes: "Linked Routes",
  linkedAgents: "Linked Agents",
  requiredInput: "This input is required",
  allowPixKeyEdit: "Allow Pix Key Edit",
  linkRoute: "LINK ROUTE",
  searchByMarket: "Search by market",
  punter: "Punter",
  userModifyPixkey: "Allow user to modify their pix key.",
  pixKey: "PIX KEY",
  removeTrack: "Remove tracks",
  remove: "Remove",
  addNewTrack: "Add New Track",
  searchToMarket: "Search by market",
  makeDeposit: "Make deposit",
  notRegisteredEmail: "Unregistered email",
  local: "Local",
  regional: "Regional",
  qtySales: "Qty. Sales",
  eventsPerBetHint:
    "To suspend betting activities, enter the value 0.00 in this field",
  maximumLimitByMarketOnEventTip:
    "This setting is applied to define how much each market of an event can support in online betting.",
  percentUserCanHighLimitTip:
    "This percentage is applied only to online users, it serves to limit how much each user can use the maximum limit.",
  disabled: "Disabled",
  groosProfit: "Gross Profit",
  accountDrawer: "Account ",
  salesLimit: "Sales Limit",
  originalTimeOdds: "Time to validate bet with original odds (minutes)",
  originalTimeOddsTip:
    "Accept quote changes between pre-bet and agent validation.",
  valueMinAccepted: "The minimum amount for bets is $ 0.50",

  // invoice: "INVOICE",
  invoiceNum: "Invoice Nº: ",
  invoiceUseLicense: "SGA.BET - Use license",
  invoiceDesctiption:
    "Discrimination: the renewal of your plan is monthly, according  to payment of the invoice presented here.",
  invoiceServiceProvider: "Service Provider:",
  invoiceBill: "Bill to Account",
  invoiceAccNumber: "Account number:",
  invoiceClient: "Client:",
  invoiceDomain: "Domain:",
  invoiceAddress: "Address:",
  invoiceCityState: "City/State:",
  invoiceZipcode: "Zipcode:",
  invoiceDateStart: "Date Start",
  invoiceDateEnd: "Date End",
  invoicePlanDescription: "Plan Description",
  invoiceTotalPrice: "Total Price ($)",
  invoiceSubTotal: "SubTotal",
  invoiceAddition: "Addition",
  invoiceDiscount: "Discount",
  invoiceObservation: "Observation:",
  invoiceThankYou: "Thank you for your preference!",
  invoiceProductCompany:
    "SGA.BET © A product of the Company TITANS SOFTWARE CORP.",
  unpaidAwards: "Unpaid Awards",
  idOperation: "Operation ID",
  consultByRegistrationDate: "Consult by Registration Date",
  byDeposit: "By Deposit",
  byBalance: "By Balance",
  exactBalance: "Exact balance",
  balanceGreaterThan: "Balance greater than:",
  balanceLessThan: "Balance less than:",
  inactive: "Inactive",
  qtyDeposits: "Qty. Deposits",
  exactQty: "Exact Qty.",
  QtyGreaterThan: "Qty. greater than:",
  QtyLessThan: "Qty. less than:",
  realiabilityFactorTip:
    "This factor serves as a multiplier of the percentage that this user can use in each market, a percentage that is defined in the bank's settings.",
  playerAffiliation: "Player Affiliation",
  marketLimits: "Market Limits",
  byAward: "By Award",
  exactAward: "Exact award",
  awardGreaterThan: "Award greater than:",
  awardLessThan: "Award less than:",
  consultLogs: "Consult Logs",
  byTypeOfUser: "Filter user type",
  backOffice: "Backoffice",
  logLegend: "When finding data, an automatic download will be performed.",
  filterAction: "Filter Action",
  inputStringLabel: "Enter a Login",

  // LOGS
  accountBlocked: "Account Blocked",
  accountSuspended: "Account Suspended",
  admPasswordUpdated: "ADM Password Updated",
  agentCreditAdded: "Agent Credit Added",
  agentCreditReseted: "Agent Credit Reset",
  agentInserted: "Agent Inserted",
  agentPasswordUpdated: "Agent Password Updated",
  agentRoutesInserted: "Agent Routes Inserted",
  agentRoutesUpdated: "Agent Routes Updated",
  agentStatusChanged: "Agent Status changed",
  agentStatusUpdated: "Agent Status Updated",
  agentUpdated: "Agent Updated",
  areaInserted: "Inserted Area",
  areaUpdated: "Area Updated",
  betCanceledLog: "Bet Cancelled",
  betPaid: "Bet Paid",
  betPaidByAdm: "Bet Paid By ADM",
  betValidated: "Bet Validated",
  bonusChanged: "Changed Bonus",
  cashoutAuthorizedByAdm: "ADM Authorized Withdrawal",
  collectorConsolidatedCash: "Consolidated Collector Cash",
  collectorEntryInserted: "Collector Entry Inserted",
  collectorRoutesInserted: "Inserted Collector Routes",
  collectorUpdated: "Collector Updated",
  commissionsUpdated: "Commissions Updated",
  changedUserStatus: "Changed User Status",
  creditCanceled: "Credit Cancelled",
  creditSold: "Credit Sold",
  depositForPlayerBillet: "Billet for Player's Deposit",
  depositOnline: "Online Deposit Paybrokers",
  depositOnlinePay4Fun: "Online Deposit Pay4Fun",
  depositOnlineBrasilCash: "Online Deposit Brasil Cash",
  entryDealInserted: "Input Agreement Inserted",
  eventCanceled: "Event Cancelled",
  eventMarketChanged: "Event Market Changed",
  eventOutcomeUpdated: "Event result Updated",
  eventStatusChanged: "Event status Changed",
  invalidLevel: "Invalid Level",
  localInserted: "Place Inserted",
  localManagerInserted: "Local Manager Inserted",
  localManagerUpdated: "Local Manager Updated",
  localManagerPasswordUpdated: "Local Manager Password Updated",
  localUpdated: "Local Updated",
  loginSuccess: "Login Successful",
  marketInserted: "Market Inserted",
  operatorConfigUpdated: "Operator Configuration Updated",
  operatorOnlineConfigUpdated: "Operator Online Configuration Updated",
  outcomesInserted: "Market Option Inserted",
  outcomeUpdated: "Updated Market Option Value",
  placeBet: "Place Bet",
  playerAddressDataUpdated: "Player Address Data Updated",
  playerBankDataUpdated: "Player Bank Details Updated",
  playerContactDataUpdated: "Player Contact Data Updated",
  playerInserted: "Player Inserted",
  playerInstantCashout: "Player Instant Withdraw",
  playerPasswordUpdated: "Player Password Updated",
  playerPersonalDataUpdated: "Player Personal Data Updated",
  playerUpdated: "Player Updated",
  preBetLog: "Pre-bet",
  insertedRegional: "Regional Inserted",
  regionalPasswordUpdated: "Updated Regional Password",
  regionalUpdated: "Regional updated",
  incompleteRegistration: "Incomplete Registration",
  tournamentEntered: "Tournament Entered",
  userUpdated: "User Updated",
  withdrawIntention: "Withdraw Intention",
  wrongPassword: "Wrong Password",
  collectorInserted: "Collector Inserted",
  userStatusUpdated: "User Status Updated",
  legendInactiveAgents: "Agents Who Haven't Placed a Bet in The Last 30 Days",
  updatedCommissions: "Updated Commissions",
  actionsContributors: "User Actions",

  // Actions Contributors
  logIntoTheSystem: "Log into the system",
  listBetsWinningLosingPending: "List bets, awarded, lost, pending",
  cancelBets: "Cancel bets",
  listAgents: "List agents",
  activateSuspendConsultAgents: "Create/Edit/Query agents",
  activateSuspendAgents: "Activate/Suspend agents",
  listLocalManagers: "List local managers",
  createEditQueryLocal: "Create/Edit/Query local managers",
  activateSuspendLocal: "Activate/Suspend local managers",
  createEditQueryRoutes: "Create/Edit/Query Routes",
  listCollectors: "List collectors",
  createEditConsultCollectors: "Create/Edit/Query collectors",
  viewAgentNetworkFinancial:
    "View your agent network's financial reports, sales, commissions, premiums paid, gross, net",
  viewFinancialStatements:
    "View financial statements, adjustments made with collectors and agents",
  viewAffiliateReports: "View Affiliate Reports",
  makeAdjustmentsAndConsolidateThem: "Make adjustments and consolidate them",
  accessToTheGeolocationOfAgents:
    "Access to the geolocation of agents in your network",
  noteSomeActionsMayDepend:
    "Note: Some actions may depend on the configuration applied to each user",
  viewYourAgentFinancialReport:
    "View your agent network's financial reports, sales, commissions, premiums paid, gross, net",
  listCreditSales: "List credit sales",
  changeYourPassword: "Change your password",
  viewFinancialReportsAgent:
    "View your financial reports, sales, commissions, premiums paid",
  validateVisitorBets: "Validate visitor bets, what we call pre-bets",
  placeDirectBets: "Place direct bets",
  sellAndListCreditSales: "Sell and list credit sales",
  accessEventTable: "Access event table",
  accessToAWeeklySummary: "Via web, access to a weekly summary (dashboard)",
  affiliatePlayers: "Affiliate players",
  registerCustomers: "Register customers",
  consultTheRoutesToCollect: "Query the routes to collect",
  consultTheFinancialHistoryOfLinkedAgents:
    "See the financial history of linked agents",
  performEntriesPayOrReceive: "Perform entries, pay or receive",
  consultEntriesMadeByManager: "Query entries made by manager",
  actionsRegionalCanPerform: "Actions the Regional Manager can perform:",
  actionsLocalCanPerform: "Actions that the Local Manager can perform:",
  actionsAgentCanPerform: "Actions that the Agent can perform:",
  actionsCollectorCanPerform: "Actions that Collector can perform:",
  betPlacedReport: "Bets placed report",
  preMatch: "Pre-match",
  matchDay: "Match Day",
  prematchAndMatchday: "Pre-match / Match Day",
  eventDate: "Date of the Event",
  totalOdds: "Total Odds",
  idBet: "Bet ID",
  cancellation: "Cancellation",
  betDate: "Bet Date",
  reportAllMarkets: "List of all markets",
  totalBets: "Total Bets",
  totalPrize: "Total Awards",
  totalCanceled: "Total Cancelled",
  totalCommissions: "Total Commissions",

  selectCountry: "Select a country",
  suspendEvent: "Suspend event",
  cancelEvent: "Cancel event",
  postponeEvent: "Postpone event",
  activateEvent: "Activate event",
  editOdds: "Edit odds",
  opening: "Opening",
  closing: "Closing",
  weHaveNoBetsOnThisEvent: "We have no bets on this event",
  allMarketsReport: "All Markets Report",
  noBetsFountForThisEvent: "No bets found for this event.",
  commissionOnTheGross: "Commission on the Gross",
  commissionOnTheNgr: "Commission on the NGR",
  commissionType: "Commission Type",
  suspensionDetails: "Suspension Details",
  suspensionDate: "Suspension Date",
  suspendedBy: "Suspended by",
  PromotionsAndbonus: "Promotions and Bonus",
  dateStart: "Start Date",
  dateFinal: "End Date",
  timeFinal: "Final time",
  limitUse: "Use Limit",
  percentage: "Percentage",
  promotionCode: "Promotion Code *",
  promotionCodeTableHeader: "Promotion Code",
  createNewPromotion: "Create Promotion",
  registerNewPromotion: "Register new promotion",
  endTime: "End Time",
  typeOfPromotion: "Type of promotion",
  typeOfPromotionSelect: "Type of promotion *",
  register: "Registration",
  noSpacesAreAllowed: "No spaces allowed",
  dateStartGreaterThanEndDate: "Start date cannot be greater than end date",
  doYouWantToDeactivateThisPromotion:
    "Do you want to Deactivate this promotion?",
  campaing: "Campaign",
  campaings: "Campaigns",
  noCode: "No code",
  numberShouldBeGreaterThanZero: "The number should be greater than zero!",
  showOrderOptional: "Show Order (Optional)",
  insertLinkOptional: "Insert Link (Optional)",
  disablePromotion: "Disable Promotion",
  newCampingMessage:
    "*The user can only participate in one registration promotion, and the Affiliate promotion overrides the Registration promotion when active in the same period. For Campaigns, use different names.",
  usageDetails: "Usage Details",
  usageAmount: "Usage amount",
  numberOfUses: "Number of uses",
  promotionTotalBonus: "Promotion Bonus Total",
  numberOfAvailableUses: "Number of available uses",
  maximumNumberOfUses: "Maximum number of uses",
  totalBonusAmountAwarded: "Total Bonus Amount awarded",
  unitaryValue: "Unit Value",
  newAffiliate: "New Affiliate",
  linkAffiliate: "Link Affiliate",
  casino: "Casino",
  transactions: "Transactions",
  game: "Game",
  gameType: "Game Type",
  tableGames: "Table Games",
  provider: "Provider",
  casinoSettings: "Casino Settings",
  selectActiveGames: "Select Games",
  createBonus: "Create Bonus",
  registerNewBonus: "Register new bonus",
  cancel: "Cancel",
  choosePlayerToApplyBonus: "Choose player to apply bonus",
  sport: "Sport",
  sports: "Sports",
  percentageCashOut: "Cash Out Percentage",
  cashOut: "Cash Out",
  bonusSettings: "Bonus Settings",
  transactionsSettings: "Transactions Settings",
  onMaintenance: "Website under maintenance",
  onMaintenanceMessage:
    "To better serve you, we are under maintenance. Please try again later.",
  overview: "Overview",
  landingPage: "Landing Page",
  makeYourLandingPage: "Build your landing page in the editor below.",
  useOurTemplate: "Use our template as a starting point:",
  loadTemplate: "Load Template",
  previewPage: "View Page",
  attention: "Attention",
  cancelPaidBetTitle: "Cancelling Paid Bet",
  cancelPaidBetContent1:
    "This bet has already been paid. Do you really want to cancel it?",
  cancelPaidBetContent2:
    "When a bet is already paid, the stake is reversed and the prize amount is debited. To do this, it is necessary to prove that the player had a balance to be debited.",
  areYouSureYouWantToCancelTheBonus:
    "Are you sure you want to cancel the bonus?",
  cancelBonus: "Cancel bonus",
  exactDepositValue: "Exact deposit",
  moreThanDepositValue: "Deposit greather than:",
  lessThanDepositValue: "Deposit less than:",
  byDepositValue: "By Deposit Value",
  duo: "Duo",
  changeOutcomeEvent: "Odd successfully modified!",
  actionCantBeUndone: "This action can't be undone!",
  scratch: "Scratch",
  liveCasino: "Live Casino",
  roulette: "Roulette",
  paymentProvider: "Provider",
  cantVerifyBank:
    "It is not possible to carry out bank verification because you only have Pay4Fun as an activated provider.",
  transfer: "Transfer",
  continue: "Continue",
  solicitedWithdrawId: "Requested Withdrawal ID",
  withdraw: "Withdraw",
  manual: "Manual",
  minDeposit: "The minimum value for deposit is $ {min_stake}.",
  maxDeposit: "The maximum value for deposit is $ 20.000.",
  cantDeactivatePaybrokers:
    "It is not possible to disable this method because you have bank verification enabled.",
  paymentProviders: "Payment Providers",
  seeMethods: "See and update payment methods",
  maxCharacters: "Número máximo de caracteres atingido",
  wallet: "Pay4Fun Wallet",
  vinculoDeposit: "Deposit Bond",
  vinculoDepositTooltip: `
    The deposit bond is a rule that prevents the withdraw of the deposited amount without using it for betting. 
    <br> With this option enabled, if a player deposited $ 100, he would only be able to withdraw this amount after he used the same amount in betting. 
    <br> With this option disabled, there will be no deposit bond generated in future deposits.
    `,
  minBet: "Minimum Stake *",
  promotionTitle: "Title *",
  title: "Title",
  and: "and",
  rolloverMultiplier: "Rollover Multiplier *",
  rolloverMultiplier2: "Rollover Multiplier",
  adhesionRules: "Adhesion Rules",
  rolloverRules: "Rollover Rules",
  promotionImage: "Promotion Image *",
  promotionImageWithoutAsterisk: "Promotion Image",
  rewardRules: "Rewards Rules",
  validity: "Validity",
  typeAndCodeOfPromotion: "Promotion Type and Code",
  maxTransferTooltip:
    "It determines the maximum amount of bonus transfer to the player's real balance through this promotion after completion of the rollover.",
  multiRolloverTooltip:
    "Multiply the BONUS VALUE acquired by the promotion to define the total rollover to be fulfilled in order to transform the bonus into a real balance. Ex: If the bonus is BRL 200.00 and the rollover multiplier is 5x. The total rollover to be completed will be BRL 1000.00",
  daysToRollover:
    "Number of days that the player will have to complete the rollover after joining the promotion.",
  transfers: "Transfers",
  freeRounds: "Casino Free Rounds",
  entryId: "Entry ID",
  userName: "User Name",
  gainedBonus: "Gained Bonus",
  transferedCredit: "Transfered Credit",
  promotionId: "Promotion ID",
  affiliateId: "Affiliate ID",
  affiliateName: "Affiliate Name",
  copyAffiliateLink: "Copy Affiliate Link",
  delete: "Delete",
  deletePromotion: "Deleting Promotion",
  areYouSureYouWantToDeleteThePromotion:
    "Are you sure you delete the promotion? This action is irreversible.",
  deletingPromotionUserRollover:
    "Users who have already opted in to this promotion will not be affected. They will be able to complete the rollover normally.",
  updatingPromotion: "Editing Promotion",
  browserCachingImage: `Sometimes the browser may "remember" the old image and
  keep showing it. To check the new image, just update
  the page or check the promotion on the site. Your image will be
  updated normally.`,
  promotionLink: "Promotion Link",
  apurationByCasinoGame: "Affiliate Apuration by Casino Games",
  deletingMainEvent: "Deleting Main Event",
  loadingEvents: "Loading events",
  addMainEvent: "Add Event to Main Events",
  removeMainEvent: "Remove Event From Main Events",
  noMainEvents: "No main event selected. Add main events in ",
  mainEvents: "Main Events",
  mainEventsWhere:
    "Main events are displayed at the top of your site, below the carousel.",
  mainEventsWeFeedIt:
    "Every day, we feed your main events with the games with the most betting potential.",
  mainEventsFinalUserSees:
    "Main events can be from any sport. Only today's events that have not yet started will be displayed to the player.",
  mainEventsYouCanAddHere: "You can add main events in ",
  prizePercentage: "Prize Percentage",
  eventNumberNeededForAgentPrizePercentage: "Number of Events Needed",
  clientGains: "Client Gains",
  savePdf: "Save PDF",
  documentVerification: "Document Verification",
  verificationOfDocument: "Verification of Document",
  loadingPlayers: "Loading players",
  validatingDocument: "Validating Document",
  documentFront: "Proof of Identity (Front)",
  documentVerse: "Proof of Identity (Back)",
  faceBiometry: "Face Picture",
  confirmPlayerValidation:
    "Do you really wanna {type} the player with ID {userId}?",
  concluded: "Concluded",
  verification: "Verification",
  documentVerificationTooltip:
    "You can review documents that have not met the automatic acceptance criteria and verify users.",
  deny: "Deny",
  lowerCaseValidate: "validate",
  lowerCaseDeny: "deny",
  accept: "Accept",
  variableCommissionSingular: "Variable Comission",
  fixedCommission: "Fixed Commission",
  commissionsOnlyInteger:
    "The commission cannot be a fractional amount, only an integer.",
  feeValueOnlyInteger:
    "The fee value cannot be a fractional amount, only an integer.",
  variableCommissions: {
    label: "Variable Comissions",
    description: `Variable commissions are custom commissions that you can
    assign to your affiliates based on their <b>NGR (GGR - Affiliate Fee)</b>. In case you
    have the variable commissions filled and select the variable commission option for the
    affiliate, the commission applied to the affiliate will be the variable.`,
    errors: {
      fromCantBeEqualOrLessThanUntil: `The "From:" value cannot be equal to or greater than the "Until:" value.`,
      from: `The "From:" value cannot be less than or equal to the previous "Until:" value.`,
      fromSuggestion: `The interval between "To:" and "Until:" cannot be greater than 1. We suggest putting the value {value}.`,
      until: `The "Until:" value cannot be less than the "From:" value.`,
      comissionBelow0: "The commission cannot be less than 0.",
      comissionBelowOnli0: "The live commission cannot be less than 0.",
      comissionAbove20: "Attention: commission greater than 20%.",
      comissionAbove20onli: "Attention: live commission greater than 20%.",
      intValue: "The commission needs to be a whole number.",
      intValueOnli: "The live commission needs to be a whole number.",
    },
  },
  profit: {
    prematch: "Prematch Estimated Profit",
    live: "Live Estimated Profit",
    superOdd: "SuperOdd Profit",
    showSuperOdd: "Show SuperOdd at event",
    tooltip:
      "SuperOdd will display the original value crossed out and the increased value highlighted when the margin is increasing the quote.",
    displayingSuperOdd: "Displaying SuperOdd!",
    hidingSuperOdd: "Hiding SuperOdd!",
  },
  commissionEqualOrGreaterThan100:
    "The entered value is above the allowed value. The maximum value for the commission is 99%.",
  commissionEqualOrGreaterThan100Onli:
    "The value entered is above the allowed limit. The maximum value for live commission is 99%.",
  feeValueEqualOrGreaterThan100:
    "The entered value is above the allowed value. The maximum value for the fee value is 99%.",
  commissionValue: "Commission Value",
  switchDescription: `This field is the affiliate's current commission mode. <br> If enabled,
the percentage of commission from that affiliate used in the calculations of
reports will be the fixed one, which is the field on the side. <br> If disabled,
the affiliate commission will be the variable, which can be configured
in the affiliate list.`,
  variable: "Variable",
  "2fa": {
    otpSent:
      "A code has been sent to your registered cell phone. Enter it here.",
    resending: "Resending",
    resendCode: "Resend Code",
    wait: "Wait {seconds}s",
    verify: "Verify",
    verifying: "Verifying",
    registerPhone: `As a security measure, it is now necessary to authenticate to two
    factors when logging into your dashboard. You don't have a cell phone registered,
    then you need to register it here to receive the authentication code.`,
    necessaryMeasure: "Necessary Measure",
    confirmPhone:
      "Confirm that this cell phone really is yours. In case of error, you will have to contact support to change it.",
    choosenPhone: "Chosen Phone: ",
    confirmPhoneTitle: "Confirm Phone",
    codeRequired: "Necessary Code",
    resendCodeShort: "Resend {seconds}s",
  },
  createNewEvent: {
    createEvent: "Create event",
    eventCreationTitle: "Create new event",
    leagueCreationTitle: "Create new league",
    drawer: "My Events",
    description:
      "My events are custom events created by you, with custom sport and league. You can also set the team odds, and after the event ends, set the winner.",
    setResult:
      "You can define a winner by clicking on the paintbrush icon in the Actions column.",
    creatingEvent: "Creating event",
    eventCreated: "Event created successfully",
    updateResult: "Update Result",
    confirmUpdateResult:
      "Attention! Confirm the selection of {selectedOdd} as the event winner?",
    marketInsert: "Market: ",
    selectWinnerAlert: {
      hasNotStarted:
        "It is not possible to select the winning odd as the event has not yet started.",
      finished: "The event has already had its winner selected.",
    },
    form: {
      selectALeague: "Select a league",
      registerOdds: "Register odds",
      registerEvent: "Register event",
      teamOne: "Team 1",
      teamTwo: "Team 2",
      leagueName: "League name",
      riskFactor: "League risk factor",
      min: "Minimum",
      med: "Average",
      max: "Maximum",
      selectWinnerOdd: "Selecionar Winner Odd",
      creatingLeague: "Creating league",
      leagueCreated: "League successfully created!",
      riskFactorDescription: `The weight of the league will influence the event's total liability amount. <br/>
      If it is a maximum, the player will be able to use the percentage that fits him in the total amount of responsibility in the event. <br/>
      If it is average, he can only bet half of the total amount of responsibility on the event. <br/>
      If it is minimum, there will be a great limitation on the total amount of liability in the event.`,
    },
    errors: {
      selectDay: "Select the day of the event.",
      invalidDay: "The event date is invalid.",
      eventDateAlreadyHappened: "The event date has already happened.",
      moreThanSevenDays:
        "Cannot insert events with start date greater than 7 days from now.",
      selectHourAndMinute: "Select the hour and minute of the event.",
      negativeHour:
        "The hour of the event can only be a positive number between 0 and 23.",
      wrongHour: "The hour of the event can only be a number between 0 and 23.",
      negativeMinute:
        "The minute of the event can only be a positive number between 0 and 59.",
      wrongMinute:
        "The minute of the event can only be a number between 0 and 59.",
      creatingEventError:
        "There was an unexpected error creating the event. Contact support.",
      noOdds: "No odds available for this market.",
    },
  },
  minActivePlayersDescription:
    "When defining a minimum number of active users for the affiliate in the period of queries that are carried out, if there is no such minimum number, the affiliate will not be commissioned. Active user: made a bet on sports or casino.",
  payments: {
    tab: "Payments",
    makePayment: "Make Payment",
    pay: "Pay",
    historic: "Historic",
    loadingAffiliates: "Loading affiliates",
    noDataFound: "No data available",
    eligibleForPayment:
      "The eligible affiliate is the affiliate that has linked a player account to your account. <br/> The affiliate can do this process by typing the account and password of his player account, in his panel at Transfers -> Link Player.",
    eligible: "Eligible",
    eligiblePlural: "Elegible",
    notEligiblePlural: "Not Elegible",
    eligibleValue: "Total Commission (Elegible)",
    valueAll: "Total Commission (All)",
    linkedPlayer: "Linked Player",
    makingPayment: {
      affiliatesBeingPaid: "Affiliates being paid: {count}",
      totalValue: "Total value:",
    },
    selectElegibleAffiliates: "Select Elegible Affiliates",
    removeElegibleAffiliates: "Remove Elegible Affiliates",
    invoiceId: "Invoice Id",
    paymentDate: "Payment Date",
    withInvoice: "With Invoice",
    withoutInvoice: "Without Invoice",
  },

  providerRequired: "Select a provider.",
  removed: "Removed",
  freespins: {
    resume: "Freespins Resume",
    totalPending: "Total Pending",
    totalActive: "Total Active",
    totalExpired: "Total Expired",
    totalRemoved: "Total Removed",
    totalFinalized: "Total Finalized",
    balanceTotal: "Total Balance",
    createCampaign: "Create Campaign",
    claimTooltip: "List of users who claimed this campaign",
    name: "Freespins",
    create: "Create campaign",
    view: "See campaign",
    update: "Update campaign",
    campaignId: "Campaign ID",
    roundsQuantity: "Number of rounds",
    loading: "Loading campaigns",
    adhesionsLoading: "Loading adhesions",
    startDate: "Date/hour start",
    endDate: "Date/hour final",
    inProgress: "In Progress",
    progressiveSpins: "Progressive Freespins",
    progressiveSpinsInfo: `Progressive freespins allow the player to receive a number of freespins proportional to the amount deposited.
    This number can vary from 1 to 4 and will be used as a divisor over the deposit amount. Two quick examples: <br>
    <ul>
    <li>
      When progressivity is set to 1, and the user deposits R$10, they will receive 10 freespins. If they deposit R$20, they will receive 20 freespins, because the amount deposited divided by 1 is the same.
    </li>
    <li>
      When progressivity is set to 2, and the user deposits €10, they will receive 5 freespins. If they deposit R$20, they will receive 10 freespins, and so on.
    </li>
    </ul>`,
    progressive: "Progressive",
    form: {
      subheaders: {
        createYourCampaign: "Create your campaign",
        editYourCampaign: "Edit your campaign",
        campaignConfigurations: "Campaign configurations",
      },
      campaignTitle: "Campaign Title",
      campaignCode: "Campaign Code",
      campaignType: "Campaign Type",
      campaignVisibility: {
        title: "Campaign visibility",
        hide: "Hide campaign",
        show: "View campaign",
        tooltip:
          "By selecting this option, the campaign will be hidden from the end user at the time of deposit (if deposit) and on the Campaigns page, but can still be joined using the code. {updateMessage}",
        tooltipUpdateMessage:
          "You can edit this option after creating the campaign.",
        },
      progressiveSpins: "Progressive Freespins",
      progressiveSpinsDivider: "Progressive Freespins (Divider)",
      game: "Game",
      users: "Users who can claim",
      doCSVUpload: "CSV upload",
      inputCsvLabel: "File",
      see: "See",
      CSVUploadTip: "The CSV file must have an 'Id' column",
      idColumnEmpty: "The 'id' column does not exist or the column values are empty",
      fileNotAllowed: "The file isn't in .csv format",
      rounds: "Amount of rounds",
      roundsHint: "From 1 to 100",
      selectAProvider: "Select a provider",
      daysToExpire: "Days to expire",
      startDate: "Start date",
      startTime: "Start hour",
      endDate: "End date",
      endTime: "End hour",
      manualUsers: "Search players that will receive freespins",
      campaignCodeTip: "Code that the player will use to join the campaign.",
      campaignMinimumDepositTip:
        "Minimum amount that the player needs to deposit to be able to join the campaign.",
      depositBondMultiplier: "Deposit bond multiplier",
      depositBondMultiplierTooltip:
        "The deposit bond ensures that the bettor plays the deposited amount before withdrawing.<br/>By setting a multiplier, up to 5, the player will have to play through the deposit amount times the set multiplier before being able to withdraw.",
      freeSpinsRolloverInfo: "The rollover multiplier ensures that the bettor plays the amount deposited before redeeming the freespins.<br/>When set up to 100x, the player will have to play the deposit amount times the multiplier set before redeeming their freespins."
    },
    campaignTypeOptions: {
      custom: "Custom",
      deposit: "Deposit",
      firstDeposit: "First deposit",
    },
    playersOptions: {
      newUsersLast30Days: "Registered in the last 30 days",
      activeLast30Days: "Active in the last 30 days",
      usersWithDeposits: "Actives that have deposited (Last 30 days)",
      usersWithoutDeposits: "Actives that have not deposited (Last 30 days)",
      addByIdOrName: "Add by ID, login or name",
      addByCsv: "Add by CSV file"
    },
    dateAndHour: "Freespin claim date and time",
    dateAndHourEnd: "Freespin expiration date and time",
    titleWhatYouWannaDo: "What do you want to do?",
    cancelPromotionAndFreespinsAdhered:
      "Cancel promotion and freespins from all players who have already joined",
    cancelFreespinsAdhered:
      "Cancel promotion without removing subscriptions already made",
    remove:
      "Are you sure you want to remove player <strong>{player}</strong> from the freespin campaign <strong>{title}</strong>?",
    removeAlert: "This action is irreversible.",
    deleteFreespinAlert:
      "Are you sure you want to disable the freespins campaign <strong>{title}</strong>?",
    removingAdhesion: "Removing adhesion",
    removingFreespin: "Deleting freespin",
    finalFreespinDate: "Final freespin date: {date}",
    notClaimed: "Not claimed",
    totalSelectedPlayers: "Total selected players:",
    selectedPlayers: "Selected Players",
    viewSelectedPlayers: "View selected players",
  },
  firstPasswordRegistration: {
    rules: {
      description: "Your password must meet these requirements:",
      oneUppercaseLetter: "At least one uppercase letter is required",
      oneLowercaseLetter: "At least one lowercase letter is required",
      oneSpecialCharacter:
        "At least one special character is required (#?!@$%^&*-)",
      oneNumber: "At least one number is required",
      eightCharacters: "Password must be exactly 8 characters",
      confirmation: "Password and confirmation must match",
    },
  },
  categoryNotFound: "Category not found",
  newInvoices: {
    name: "New Invoices",
    oldInvoices: "Old Invoices",
    appliedValue: "Applied Value",
    readQrCode: "Read the QR Code",
    copyPixCode: "Copy PIX Code",
    loading: "Loading invoices...",
    generatePix: "Generate Pix",
    overdue: "Overdue",
    invoiceValue: "Invoice Value",
    feeValue: "Fee Value",
  },
  fixed: "Fixed",
  cpfTooltip:
    "This field is intended for the CPF of the person responsible for the operation. This field will be used to generate system invoices, if you need to modify it, look for the financial sector or account manager",
  billingEmailTooltip:
    "This email must be filled in with a valid email, as it will be used as a sender for sending confirmation emails, account recovery, among others.",
  pixPhysicalPersonAlert:
    "Very important: This pix must be paid with a Physical Person account, not a Juridical Person account.",
  revShareValue: "Rev Share Value",
  fixedOdd: "Fixed Odds",
  hidePromotionTooltip:
    "By selecting this option, the promotion will be hidden from the end user at the time of deposit (if deposit) and on the Promotions page, but can still be entered using the code. It is possible to edit this option after creating the promotion.",
  hidePromotionTooltipUpdateMessage:
    "You can edit this option after creating the promotion.",
  loadingPromotions: "Loading promotions",
  promotionVisibility: "Promotion visibility",
  visibility: "Visibility",
  hidePromotion: "Hide promotion",
  hidden: "Hidden",
  displayed: "Displayed",
  createNewWebhook: "Create new webhook",
  editWebhook: "Edit webhook",
  loadingWebhooks: "Loading webhooks",
  marginChangedAlertMessage:
    "The change in the {type} margin from {oldMargin} to {currentMargin} can benefit users at the time of cashout.",
  testWebhook: "Test webhook",
  whatAreWebhooks: `Webhook is a technology used to allow communication between two applications and send notifications in real time.
  <br />
  When registering a webhook, you will receive a notification at the URL provided whenever the chosen action is completed.`,
  unexpectedError: "An unexpected error occurred.",
  dataBeingSent: "Data being sent (JSON)",
  response: "Response",
  success: "Success",
  error: "Error",
  hide: "Hide",
  emailVerification: {
    name: "Email verification upon withdrawal",
    button: "Verify email",
    dialogTitle: "Verify player email",
    description: "This action will make the player able to realize withdraws.",
    areYouSure:
      "Are you sure you want to check the player's email? This action can't be undone.",
    forWithdraws: `By selecting “Yes”, the player will only be able to make a withdrawal if their email is verified. (Recommended)
    By selecting “No”, the player will be able to make a withdrawal without prior verification.`,
  },
  claims: "Claims",
  multifactor: {
    field: "Two-factor authentication",
    tooltip:
      "Two-factor authentication allows users to activate an extra layer of security in their accounts, receiving a code on their cell phone when they log in to the platform.",
  },
  homePage: {
    field: "Main page",
    tooltip:
      "This is the page your visitors will see first when they access your website.",
  },
  expenses: {
    logs: {
      createExpense: "Affiliate Expense Creation",
      editExpense: "Affiliate Expense Edit",
      removeExpense: "Affiliate Expense Removal",
    },
  },
  affiliatesCampaigns: {
    noData: "There are no active campaigns. | There are no inactive campaigns.",
    noDataFound: "No campaigns found.",
    name: "Campaign name",
    campaignCode: "Campaign code",
    affiliateName: "Affiliate name",
    numberOfClicks: "Qty. of clicks",
    numberOfUsers: "Qty. of users",
    socialMedia: "Social media",
    others: "Others",
    activate: "Activate",
    deactivate: "Disable",
    activateOrDesactivate: "Activate or deactivate",
    createdDate: "Created date",
    updatedDate: "Updated date",
  },
  sortBy: "Sort by",
  activeCampaigns: "Active Campaigns",
  desactiveCampaigns: "Inactive Campaigns",
  resultsPlurals: "result | results",
  usersPlurals: "User | Users",
  depositsPlurals: "Deposit | Deposits",
  withdrawalsPlurals: "Withdrawal | Withdrawals",
  noQuery: "No query performed",
  lastLogin: "Last login",
  birthday: "Birthday",
  noDataText: "No data",
  noResultsText: "There is no data for this search",
  finishedIn: "Finalized in",
  withdrawalStatus: {
    requested: "Requested",
    authorized: "Authorized",
    consolidated: "Consolidated",
    cancelled: "Cancelled",
  },
  activateOrDesactivateCampaign: {
    title: "Confirm action",
    description: {
      activate: "Are you sure you want to activate the campaign: ",
      desactivate: "Are you sure you want to deactivate the campaign: ",
    },
  },
  lastBetTime: "Last bet time",
};
export default en;
